import { useState, useEffect, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './utils/firebase.utils';

import { initGA } from './analytics';
import usePageViews from './hooks/usePageViews';

import TreeLogo from './components/tree-logo/tree-logo.component';
import MenuSlide from './components/menu-slide/menu-slide.component';

// import appBackground from './jpeg/view/d.jpg';
// import appBackground from './jpeg/view/l.png';

import Background from './atoms/background/background.component';
import HomePage from './pages/home-page/home-page.page';

import { 
  PopUpContext, 
  MenuContext
} from './contexts/ui.context';

import { UserContext, UserNameContext } from './contexts/user.context';

import ScrollToEcommerce from './pages/scrollpage/scroll-to-ecommerce';
import ScrollToSoftware from './pages/scrollpage/scroll-to-software';
import ScrollToMarketing from './pages/scrollpage/scroll-to-marketing';
import ScrollToBlogs from './pages/scrollpage/scroll-to-blogs';
import ScrollToOptions2 from './pages/scrollpage/scroll-to-menu2';

import ChattingPage from './pages/chat-page/chat-page.page';

import SignIn from './components/signin/signin.component';
import Profile from './pages/profile/profile.page';
import Services from './pages/services/services.page';
import BlogPage from './pages/blog/blog.component';
import LaunchStorePage from './pages/launch-store/launch-store.page';
import FreeAuditPage from './pages/free-audit/free-audit.page';
import MyWebpage from './pages/mywebpage/mywebpage.page';
import NoneAvailable from './pages/noneavailable/noneavailable.component';
import About from './components/about/about.component';
import ContactUs from './pages/contactus/contactus.component';
import Blog from './pages/blog/blog.component';
import PrivacyLegal from './pages/privacylegal/privacylegal.page';
import FreeEcomSite from './landing-pages/free-ecom-website/free-ecom-website.page';

import MyWebAccess from './pages/my-web-access/my-web-access.page';

import './App.scss';


const App = () => {
  const { currentMenu, setCurrentMenu } = useContext(MenuContext);
  const { currentPopUp } = useContext(PopUpContext);

  const { currentUser, setCurrentUser } = useContext(UserContext);
  const { userName, setUserName } = useContext(UserNameContext);

  const [userPath, setUserPath] = useState(null);

  // const { currentUser } = useContext(UserContext);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      // if (user && user.displayName) {
      //   const formattedName = user.displayName.replace(/\s/g, ""); // Remove spaces
      //   setUserPath(formattedName);
      // } else {
      //   setUserPath(null);
      // }
      if (user) {
        const formattedName = user.displayName.replace(/\s/g, "");
        setCurrentUser(user);
        setUserName(user.email.split("@")[0]);
      } else {
        setCurrentUser(null);
        setUserName(null);
      }
    });

    return () => unsubscribe();
  }, []);


  useEffect(() => {
    initGA();
  }, []);

  usePageViews(); 

  const [scrollPosition, setScrollPosition] = useState(0);

  // const { currentFootLink } = useContext(FootLinkContext);

  const [ footerTop, setFooterTop ] = useState('0%');
  const [ footSymbol, setFootSymbol ] = useState(null);



  const handleScroll = (scrollTop) => {
      setScrollPosition(scrollTop);
  };


  const toggleMenu = () => {
    setCurrentMenu(false);
  };

  const toggleFooter = () => {
    footerTop === '0%' ?
      setFooterTop('-50%')
      : setFooterTop('0%') ;
  };


  useEffect(() => {
    const now = footerTop === '0%' ? '+' : 'x';
    setFootSymbol(now);
  }, [footerTop])


  const arrange = () => {
    if(currentMenu === true)
      setCurrentMenu(false)

    if(footerTop !== '0%')
      setFooterTop('0%')
  }

  


  return (
    <>
      <div 
        className="app-container" 
        onClick={arrange}
        style={{
          top: footerTop,
          // backgroundImage: `url(${appBackground})`,
      }}>
        <TreeLogo bg={scrollPosition > 0 
          ? 'rgba(000, 000, 000, 0.7)' 
          : 'rgba(000, 000, 000, 0)'}
        />
        <Routes>
          <Route path="/" element={ <HomePage onScroll={handleScroll} /> } />
          {/* <Route path="/" element={ <First top={footerTop} /> } /> */}
          <Route path="/services" element={ <Services onScroll={handleScroll} /> } />
          <Route path="/aboutus" element={ <About onScroll={handleScroll} /> } />
          <Route path="/blogs" element={ <Blog  onScroll={handleScroll}/> } />
          <Route path="/contactus" element={ <ContactUs  onScroll={handleScroll} /> } />
          <Route path="/privacy&legal" element={ <PrivacyLegal onScroll={handleScroll} /> } />
          <Route path="/free-ecommerce-website" element={ <FreeEcomSite onScroll={handleScroll} /> } />
          <Route path="/blog" element={ <BlogPage onScroll={handleScroll} /> } />
          <Route path="/launch-store" element={ <LaunchStorePage onScroll={handleScroll} /> } />
          <Route path="/free-audit" element={ <FreeAuditPage onScroll={handleScroll} /> } />
          <Route path="/*" element={<NoneAvailable />} />

          <Route path="/signin" element={ <SignIn /> } />
          <Route path="/chat" element={ <ChattingPage /> } />
          <Route path="/1122111" element={ <MyWebAccess /> } />

          {currentUser && <Route 
          path={`/profile/${userName}`} 
          element={<Profile username={userName} />} 
          />}

          {currentUser !== null 
          ? <Route path={`/${userName}`} element={<MyWebAccess />} />
          : null
          }

          <Route path="/services/marketing" element={ <ScrollToMarketing  onScroll={handleScroll} /> } />

          <Route path="/mywebpage" element={ <MyWebpage  onScroll={handleScroll} /> } />
          //JUST INCASE

          {
          /*<Route path="company" element={ <ScrollToOptions2/> } />
          // <Route path="/services/ecommerce" element={ <ScrollToEcommerce  onScroll={handleScroll} /> } />
          <Route path="/services/software" element={ <ScrollToSoftware  onScroll={handleScroll} /> } />
          <Route path="/services/marketing" element={ <ScrollToMarketing  onScroll={handleScroll} /> } />
          <Route path="/company/aboutus" element={ <About onScroll={handleScroll} /> } />
          <Route path="/company/blogs" element={ <Blog  onScroll={handleScroll}/> } />
          <Route path="/company/contactus" element={ <ContactUs  onScroll={handleScroll} /> } />
          */}
        </Routes>
        {currentPopUp}
        <Background />
      </div>
      <MenuSlide isOpen={currentMenu} onClose={toggleMenu} />
      
    </>
  );
}

export default App;